import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, IvfEmbryoGradingByCycleController, IvfEmbryoGradingByCycleRequest, EmbryosFromStoreController, EmbryosFromStoreRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { OocyteStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfoqaedit.component';
import { EmbryoStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfgradingedit.component';




@Component({
  selector: 'fet',
  templateUrl: './fet.component.html',
  styleUrls: ['./fet.component.scss']
})

export class FetPVComponent implements OnInit {

  //@Input() CycleCode: number;
  //@Input() TitleText: string;
  //@Input() DOC: string;

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public EndometriumThickness: number;
  public LeftOvaries: number;
  public RightOvaries: number;
  public MedicineName: string;
  public TestName: string;
  public TestName1: string;
  public Owner: string;
  public FormattedCode: string;
  public Protocolst: string;
  public ProtocolEd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string;
  public CycleNo: string;
  public CycleType: string;
  public TotalOocytes: string;
  public Date: Date;
  public TransferedCount: number;
  public FrozenCount: number;
  public DiscardedCount: number;
  public TotalCout: number; 
  public TreatmentCycleCodedata: any;
  public ActorCodedata: any;
  public EggSourceData: string;
  public DonorData: string;
  public DonorCode: string;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public Doc: string;
  public DocDate: string;

  CurrentEmbryosFromStoreController: EmbryosFromStoreController[];

  CurrentEmbryosFromStoreRequest: EmbryosFromStoreRequest;
  LoadFET() {
    this.CurrentEmbryosFromStoreRequest = new EmbryosFromStoreRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentEmbryosFromStoreRequest.ActorCode = this.ActorCodedata;
    this.CurrentEmbryosFromStoreRequest.DOC = "";
    this.CurrentEmbryosFromStoreRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentEmbryosFromStoreRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetEmbryosFromStoreController();
  }

  GetEmbryosFromStoreController() {
    //this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetEmbryosFromStoreController(this.CurrentEmbryosFromStoreRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentEmbryosFromStoreController = this.ApiResData.Result;

          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadPatients();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }




  CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  LoadPatients() {
    this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;
    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date(2017, 1, 1);// "1-JAN-2017";
    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();// "31-DEC-2018";
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetCycleOocyteQualityBetweenDateController();
  }

  GetCycleOocyteQualityBetweenDateController() {
    this.StartRefreshing();


    this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.Doc = this.route.snapshot.paramMap.get('Doc');
    this.DocDate = this.route.snapshot.paramMap.get('DocDate');
    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.FormattedCode = this.route.snapshot.paramMap.get('PatientId');
    this.Protocolst = this.route.snapshot.paramMap.get('ProtocolStart');
    this.ProtocolEd = this.route.snapshot.paramMap.get('ProtocolEnd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.TotalOocytes = this.route.snapshot.paramMap.get('TotalOocytes');
    this.TreatmentCycleCodedata = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.ActorCodedata = this.route.snapshot.paramMap.get('ActorCodedata');
    this.EggSourceData = this.route.snapshot.paramMap.get('EggSourceData');
    this.DonorData = this.route.snapshot.paramMap.get('DonorData');
    this.DonorCode = this.route.snapshot.paramMap.get('DonorCode');

    this.LoadFET();

  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








